import { Grid } from '@mui/material';
import { styles } from './styles';
import { ReactNode } from 'react';

export const HeadingAddon = ({ children }: { children: ReactNode }) => {
  return <Grid sx={styles.container}>{children}</Grid>;
};
